module Meevo.Plugins.Distributors {
    "use strict";

    /**
    * Notes Section of distributors 
    */
    export class NotesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Distributor> {


    }

}